import React from 'react';
import {observer} from 'mobx-react';

import ExtraInfo from 'core/components/ExtraInfo.js';
import Link from 'core/components/Link.js';
import HicapsBadge from 'core/components/HicapsBadge.js';
import {PracticeStoreContext} from 'core/stores/RootStore.js';
import LocationList from 'practices/components/LocationList.js';

@observer
export default class PracticeSidebar extends React.Component {
    static contextType = PracticeStoreContext;

    renderHicaps() {
        const {practice, isPracticeGroup} = this.context;

        if (isPracticeGroup) {
            const offersHicaps = practice.locations?.find(
                (prac) => prac.offersHicaps,
            );
            if (offersHicaps) {
                return (
                    <div>
                        <HicapsBadge />
                    </div>
                );
            }
        }

        if (practice.offersHicaps) {
            return <HicapsBadge isPracticeLocation />;
        }

        return null;
    }

    render() {
        let googlePreviewUrl;
        let hasStaticMapUrl = false;
        const {
            isHospitalPage,
            isPracticeGroup,
            practice,
            practiceLoaded,
        } = this.context;
        const {nearbyHospitals} = practice;

        if (!practiceLoaded) {
            return null;
        }
        if (practice.streetAddress && practice.locality) {
            googlePreviewUrl = `https://www.google.com/maps/preview/?q=${practice.streetAddress}${practice.locality}`;
        }
        if (isHospitalPage && practice.address) {
            googlePreviewUrl = `https://www.google.com/maps/preview/?q=${practice.address}`;
        }
        if (
            !isPracticeGroup ||
            practice.locations?.length > 0 ||
            nearbyHospitals?.length > 0
        ) {
            hasStaticMapUrl = true;
        }

        let staticMapUrl = practice.staticMapUrl;
        if (window.devicePixelRatio >= 2) {
            staticMapUrl = practice.staticMapUrlHighDpi;
        }

        return (
            <section className="tray">
                {hasStaticMapUrl && !nearbyHospitals?.length && (
                    <figure className="map">
                        {googlePreviewUrl ? (
                            <Link
                                href={googlePreviewUrl}
                                isExternalLink={true}
                                title="View on Google Map"
                            >
                                <img src={staticMapUrl} />
                            </Link>
                        ) : (
                            <img src={staticMapUrl} />
                        )}
                    </figure>
                )}
                {this.renderHicaps()}
                {hasStaticMapUrl && <LocationList />}
                {!isPracticeGroup && (
                    <ExtraInfo
                        comment={practice.extraInfo?.comment}
                        disabledAccess={practice.disabledAccess}
                        onsiteParking={practice.onsiteParking}
                        openHours={practice.extraInfo?.openHours}
                        openIndicator={practice.openIndicator}
                        paymentOptions={practice.extraInfo?.paymentOptions}
                        serviceOptions={practice.extraInfo?.serviceOptions}
                    />
                )}
            </section>
        );
    }
}
